import { render, staticRenderFns } from "./ProductsInPrestage.vue?vue&type=template&id=ab5ca20a&scoped=true&"
import script from "./ProductsInPrestage.vue?vue&type=script&lang=js&"
export * from "./ProductsInPrestage.vue?vue&type=script&lang=js&"
import style0 from "./ProductsInPrestage.vue?vue&type=style&index=0&id=ab5ca20a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab5ca20a",
  null
  
)

export default component.exports